(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/hooks/use-favorites.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/hooks/use-favorites.js');
"use strict";


const {
  useState,
  useEffect,
  useCallback
} = React;
const {
  favoritesApi
} = svs.components.casino_react.casinoStore.endpoints;
const {
  showMaxFavoritesDialog,
  MAX_FAVORITES
} = svs.components.casino_react.maxFavoritesDialog;
const useFavorites = () => {
  const [favorites, setFavorites] = useState([]);
  const [isPending, setIsPending] = useState(false);
  const userLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const {
    data: fetchedFavorites = []
  } = favoritesApi.useGetFavoritesQuery(undefined, {
    skip: !userLoggedIn
  });
  const [updateFavorites] = favoritesApi.useUpdateFavoritesMutation();
  useEffect(() => {
    setFavorites(fetchedFavorites);
  }, [fetchedFavorites.length]);
  const isFavorite = useCallback(gameName => favorites.includes(gameName), [favorites]);
  const addFavorite = useCallback(async gameName => {
    if (favorites.length >= MAX_FAVORITES) {
      showMaxFavoritesDialog();
      return {
        success: false,
        error: 'Max favorites reached'
      };
    }
    setIsPending(true);
    const newFavorites = [gameName, ...favorites];
    setFavorites(newFavorites);
    const result = await updateFavorites(newFavorites);
    setIsPending(false);
    if (result.error) {
      setFavorites(favorites);
      return {
        success: false,
        error: result.error.message
      };
    }
    return {
      success: true
    };
  }, [favorites, updateFavorites]);
  const removeFavorite = useCallback(async gameName => {
    setIsPending(true);
    const newFavorites = favorites.filter(name => name !== gameName);
    setFavorites(newFavorites);
    const result = await updateFavorites(newFavorites);
    setIsPending(false);
    if (result.error) {
      setFavorites(favorites);
      return {
        success: false,
        error: result.error.message
      };
    }
    return {
      success: true
    };
  }, [favorites, updateFavorites]);
  const toggleFavorite = useCallback(async gameName => {
    if (isFavorite(gameName)) {
      return await removeFavorite(gameName);
    }
    return await addFavorite(gameName);
  }, [isFavorite, addFavorite, removeFavorite]);
  return {
    favorites,
    isPending,
    isFavorite,
    toggleFavorite,
    isLoggedIn: userLoggedIn
  };
};
setGlobal('svs.components.casino_react.casinoStore.hooks.useFavorites', useFavorites);

 })(window);